'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactToastify = require('react-toastify');

require('react-toastify/dist/ReactToastify.css');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var WithMessage = (_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(WithMessage, _React$Component);

  function WithMessage() {
    (0, _classCallCheck3.default)(this, WithMessage);
    return (0, _possibleConstructorReturn3.default)(this, (WithMessage.__proto__ || Object.getPrototypeOf(WithMessage)).apply(this, arguments));
  }

  (0, _createClass3.default)(WithMessage, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        showMessage: this.showMessage
      };
    }
  }, {
    key: 'showMessage',
    value: function showMessage(message, passedOptions) {
      var options = (0, _extends3.default)({
        message: typeof message === 'string' ? message.replace('GraphQL error: ', '') : message,
        level: 'info'
      }, passedOptions);
      _reactToastify.toast.info(options.message);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.children,
        _react2.default.createElement(_reactToastify.ToastContainer, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          newestOnTop: false,
          closeOnClick: true,
          rtl: false,
          pauseOnFocusLoss: true,
          draggable: true,
          pauseOnHover: true,
          theme: 'dark'
        })
      );
    }
  }]);
  return WithMessage;
}(_react2.default.Component), _class2.propTypes = {
  children: _propTypes2.default.node
}, _class2.childContextTypes = {
  showMessage: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'showMessage', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'showMessage'), _class.prototype)), _class);
exports.default = WithMessage;